






















import Vue from 'vue';
import { mapActions } from 'vuex';

import { SamlSettings } from '@/pages/settings/authentication/types';

import SpSettings from './SpSettings.vue';
import UploadMetadata from './UploadMetadata.vue';
import IdpSettings from './IdpSettings.vue';

export default Vue.extend({
  name: 'SettingsTab',
  components: {
    SpSettings,
    UploadMetadata,
    IdpSettings,
  },
  props: {
    samlSettings: {
      type: Object as () => SamlSettings,
      default: {},
      required: true,
    },
    validations: {
      type: Array,
      required: true,
    },
  },
  async created() {
    this.setPageTitle({ title: 'Settings' });
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
  },
});
